require('./brokerContributionInvestmentFundDetails.scss');

const PropTypes = require('prop-types');

// @ vendors
const React = require('react');
const classNames = require('classnames');
const Immutable = require("immutable");
const moment = require('moment');
const { DATE_FORMAT_DAY_MONTH_YEAR } = require('constants/index');



// @ helpers
const { FormattedText } = require('core/i18n').i18n;
const { getFormattedString } = require('utilities/currencyHelper');
const { toCamelCase } = require('utilities/stringHelper');
const IbanHelper = require('utilities/ibanHelper');
// @ constants
const {
    API_ENTERPRISE_NUMBER,
    API_CENTER,
    BROKER_FUNDS_SUBSCRIPTION_CONTRACT_FORMAT
} = require('constants/index');

const { INTERVENER_CODES } = require('constants/interveners')
class BrokerContributionInvestmentFundDetails extends React.Component {
    buildAccount(index) {
        const { immAccount, immContributionFunds } = this.props;
        const accountNumberPrefix = `${API_ENTERPRISE_NUMBER}${API_CENTER}`;
        const accountContractNumber = immAccount.get('contractNumber');
        const accountProductNumber = immAccount.get('product');
        const accountCodbban = immAccount.getIn(['ibanComplex', 'codbban']);
        const accountControlDigit = accountCodbban.substring(8, 10);
        const fullAccountNumber = IbanHelper.formatAccountTextWithSpaces(
            `${accountNumberPrefix}${accountControlDigit}${accountProductNumber}${accountContractNumber}`,
            BROKER_FUNDS_SUBSCRIPTION_CONTRACT_FORMAT
        );
        const accountHolders = immAccount.get("accountHolder") || "";
        const accountName = immAccount.getIn(['catalogData', 'product']);
        const contractNumber = immContributionFunds.getIn(['steps', 0, 'originFundPurchased', 'contractNumber']);
        const productNumber = immContributionFunds.getIn(['steps', 0, 'originFundPurchased', 'product']);
        const fullFundContractNumber = `${API_ENTERPRISE_NUMBER}${API_CENTER}${productNumber}${contractNumber}`
        const accountAlias = immAccount.get('alias');

        return (
            <div key={index} className="contribution-fund-details__center col-lg-4">
                <div className="contribution-fund-details__center-panel">
                    <div className="contribution-fund-details__center-panel-fist-block">
                        <div className="contribution-fund-details__text">
                            {accountAlias}
                        </div>
                        <div className="contribution-fund-details__bold-text">
                            {toCamelCase(accountName)}
                        </div>
                        <div className="contribution-fund-details__secondary-text">
                            {fullAccountNumber}
                        </div>
                    </div>
                    <div className="contribution-fund-details__secondary-text">
                        <FormattedText
                            value="brokerContributionFundSuccess-contract"
                            className="contribution-fund-details__secondary-text"
                        />
                        <div className="contribution-fund-details__secondary-text contribution-fund-details__inline">
                            {fullFundContractNumber}
                        </div>
                    </div>
                    <div className="contribution-fund-details__secondary-text">
                        <FormattedText value="brokerContributionFundSuccess-holder" />
                        {accountHolders}
                    </div>
                </div>
            </div>
        );
    }

    buildContributionDetails(index) {
        const { immAccount, immContributionFunds } = this.props;
        const periodicityLabel = immContributionFunds.getIn(['steps', 0, 'periodicityLabel']);
        const currencyObject = Immutable.Map().merge({
            amount: immContributionFunds.getIn(["steps", 0, "amount"]),
            currency: immAccount.getIn(["balance", "currency"]),
        });
        const amountInvestment = getFormattedString(currencyObject);
        const selectedDate = immContributionFunds.getIn(['steps', 0, 'selectedDate']);
        const date = selectedDate.format(DATE_FORMAT_DAY_MONTH_YEAR).toString();
        return (
            <div key={index} className="contribution-fund-details__center col-lg-4">
                <div className="contribution-fund-details__center-panel">
                    <div className="contribution-fund-details__center-panel-fist-block">
                        <div className="contribution-fund-details__text">
                        <FormattedText value="brokerContributionFundSuccess-periodicity" />
                        </div>
                        <div className="contribution-fund-details__bold-text">
                            {`${amountInvestment} ${periodicityLabel}`}
                        </div>
                    </div>
                    <div className="contribution-fund-details__center-panel-fist-block">
                        <div className="contribution-fund-details__secondary-text">
                            <FormattedText value="brokerContributionFundSuccess-firstContribution" />
                        </div>
                        <div className="contribution-fund-details__text">
                            {date}
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    render() {
        const table = this.props.columns.map((column, index) => {
            if (column === 'account') {
                return this.buildAccount(index);
            } else if (column === 'contributionDetails') {
                return this.buildContributionDetails(index)
            }
            else
                return (
                    <div
                        key={index}
                        className="contribution-fund-details__left col-lg-3 contribution-fund-details__text"
                    >
                        <div className="contribution-fund-details__left-text">
                            <FormattedText value={column} />
                        </div>
                        <div className="contribution-fund-details__bold-text">
                            {this.props.columnsContent[index]}
                        </div>
                    </div>
                );
        });

        return (
            <div className="contribution-fund-details">
                <div className="row">
                    {table}
                </div>
            </div>
        );
    }
}

BrokerContributionInvestmentFundDetails.propTypes = {
    columns: PropTypes.array.isRequired,
    columnsContent: PropTypes.array.isRequired,
    immAccount: PropTypes.object.isRequired,
    immInvestmentFunds: PropTypes.object.isRequired
};

module.exports = BrokerContributionInvestmentFundDetails;
